import { ChevronUpIcon } from "@heroicons/react/24/outline";
import { Disclosure } from "@headlessui/react";
import { RecordingTranscriptPair } from "../../utils/SessionUtils";
import { RecordingTranscriptPairTitle } from "./RecordingTranscriptPairTitle";
import { getNodeStatusColor } from "../../utils/MetagraphUtils";
import { RecordingTranscriptPairBody } from "./RecordingTranscriptPairBody";
import ConfirmDeleteModal from '../ConfirmDeleteModal';
import { useState } from "react";

interface RecordingTranscriptPairBlockProps {
    recordingTranscriptPair: RecordingTranscriptPair;
    downloadFileName: string;
    defaultOpen?: boolean;
    source?: string;
    sessionLanguage?: string;
    processRecordings?: () => Promise<void>
    handleDeleteRecording?: (id: string) => Promise<void>
}

export const RecordingTranscriptPairBlock: React.FC<RecordingTranscriptPairBlockProps> = ({ recordingTranscriptPair, downloadFileName, defaultOpen, source, processRecordings, handleDeleteRecording }) => {
    const transcriptStatus: string = recordingTranscriptPair.transcript_status;
    const color = getNodeStatusColor(transcriptStatus)
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    return (
        <div className="w-full rounded-lg bg-white">
            {handleDeleteRecording && <ConfirmDeleteModal 
                isOpen={showDeleteModal}
                title="Delete Recording"
                message="Are you sure you want to delete this recording? This action cannot be undone."
                onConfirm={() => {
                    setShowDeleteModal(false);
                    (async () => {
                        await handleDeleteRecording(recordingTranscriptPair.recording_id)
                    })().catch((err: unknown) => {
                        console.error('error deleting recording', err);
                    })
                }}
                onCancel={() => setShowDeleteModal(false)}
            />}
            <Disclosure defaultOpen={defaultOpen}>
                {({ open }) => (<>
                    <Disclosure.Button className={`flex w-full justify-between items-center ${open ? "rounded-t-lg" : "rounded-lg"} bg-${color}-100 px-4 py-2 text-left text-sm font-semibold text-${color}-900 hover:bg-${color}-200 focus:outline-none focus-visible:ring focus-visible:ring-${color}-500/75 h-12`}>
                        <RecordingTranscriptPairTitle recordingTranscriptPair={recordingTranscriptPair} />
                        <ChevronUpIcon className={`${open ? 'rotate-180 transform' : ''} h-5 w-5 text-${color}-500 stroke-[3] transition-transform duration-300`} />
                    </Disclosure.Button>
                    <Disclosure.Panel className="text-sm">
                        <RecordingTranscriptPairBody 
                            recordingTranscriptPair={recordingTranscriptPair}
                            downloadFileName={downloadFileName}
                            source={source}
                            processRecordings={processRecordings}
                            handleDeleteClick={handleDeleteRecording ? () => setShowDeleteModal(true) : undefined}
                        />
                    </Disclosure.Panel>
                </>)}
            </Disclosure>
        </div>
    );
};